export default "__VITE_ASSET__BV8u8SdL__"